import React, { useEffect } from "react";
import FormContact from "./FormContact";
import AuthIcons from "./AuthIcons";
import ScrollIndicator from "./ScrollIndicator";
import useScrollToTop from "../../hooks/useScollToTop";
import { useUser } from "./UserContext";
import { saveVisite } from "../../services/visitesServices";
import HomeHeroSection from "./HomeHeroSection";
import HomeQuickShortcuts from "./HomeQuickShortcuts";
import HomeFeaturesOnboarding from "./HomeFeaturesOnboarding";
import PartnersMarquee from "./PartnersMarquee";
import HomeUpcomingEvents from "./HomeUpcomingEvents";

function HomePageVitrine() {
  useScrollToTop();
  const { user } = useUser();
  const isConnected = !!user;

  useEffect(() => {
    const today = new Date().toISOString().slice(0, 10);
    const lastVisitDate = localStorage.getItem("lastVisitDate");

    if (lastVisitDate !== today) {
      saveVisite({})
        .then(() => {
          localStorage.setItem("lastVisitDate", today);
        })
        .catch((error) => {
          console.error(
            "Erreur lors de l'enregistrement de la visite :",
            error
          );
        });
    }
  }, []);

  return (
    <div className="min-h-screen bg-slate-50 text-slate-900">
      {!isConnected && <AuthIcons />}
      <ScrollIndicator />

      <HomeHeroSection />

      <main>
        <section
          id="quick-shortcuts"
          className="scroll-mt-[100px] md:scroll-mt-[115px] py-8 sm:py-10 lg:py-12"
        >
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="rounded-[28px] border border-slate-200 bg-white p-4 shadow-sm sm:p-6 lg:p-8">
              <div className="mb-6 flex flex-col gap-2">
                <p className="inline-flex w-fit rounded-full bg-emerald-50 px-3 py-1 text-xs font-semibold uppercase tracking-[0.18em] text-emerald-700">
                  Raccourcis
                </p>
                
              </div>

              <HomeQuickShortcuts />
            </div>
          </div>
        </section>

        <section className="bg-gradient-to-b from-slate-50 via-white to-slate-50 py-10 sm:py-14">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <HomeFeaturesOnboarding />
          </div>
        </section>

        <HomeUpcomingEvents />

        <section id="contact" className="py-10 sm:py-14">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="rounded-[28px] border border-slate-200 bg-white p-4 shadow-sm sm:p-6 lg:p-8">
              <FormContact />
            </div>
          </div>
        </section>

        <section className="border-t border-slate-200/80 bg-white py-6 sm:py-8">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <PartnersMarquee />
          </div>
        </section>
      </main>
    </div>
  );
}

export default HomePageVitrine;